import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useTableCellStyles = makeStyles({
	root: {
		padding: '0.7px 0px 1px 0px',
		border: 'none',
		'&:last-child': {
			paddingRight: 0
		},
		'&:first-child': {
			width: '150px',
			fontSize: '13px'
		}
	},
	values: {
		color: COLORS.SECONDARY,
		fontWeight: 'bold'
	}
});
